import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="28" height="28" rx="14" fill="#FF7C03" />
      <path
        d="M16 10C15.4477 10 15 10.4477 15 11V17C15 17.5523 15.4477 18 16 18C16.5523 18 17 17.5523 17 17V11C17 10.4477 16.5523 10 16 10Z"
        fill="white"
      />
      <path
        d="M16 20C15.4477 20 15 20.4477 15 21C15 21.5523 15.4477 22 16 22C16.5523 22 17 21.5523 17 21C17 20.4477 16.5523 20 16 20Z"
        fill="white"
      />
    </svg>
  );
};

export default Svg;
